import { getQuery } from 'utilities/query';
import templateUrl from './bulk-usage-data.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    usages: '<',
    onUsagesSubmitted: '&'
  },
  controller: class BulkUsageDataComponent {
    constructor(EventEmitter, UsageDataService) {
      'ngInject';

      Object.assign(this, {
        EventEmitter,
        UsageDataService
      });
    }

    $onInit() {
      this.Q4Value = 0;
      this.query = {
        ...getQuery(),
        take: 5
      };
      this.limitOptions = [5, 10, 25, 50];
      this.getQ4Value();
    }

    getQ4Value() {
      const promise = this.UsageDataService
      .getQ4Value(this.usages[0].ProductId, (this.usages[0].UsageYear - 1));

      return promise.then((result) => {
        this.Q4Value = result.data;
      });
    }

    showWarning(value1, value2) {
      if (((value1 - value2) / value2) > 1) {
        return true;
      } else if (((value2 - value1) / value1) > 1) {
        return true;
      }
      return false;
    }

    showWarningMessage() {
      const errors = document.getElementsByClassName('error-icon');
      if (errors.length > 0) {
        if (errors.length === 1 && errors[0].classList[1] === 'warning-message') {
          return false;
        }
        return true;
      }
      return false;
    }

    onSubmit() {
      this.onUsagesSubmitted(
        this.EventEmitter({
          usages: this.usages
        })
      );
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/common/bulk-usage-data/bulk-usage-data.component.js